import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';

// Services
import { AirportWatchService } from '../../../services/airportwatch.service';

// Models
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AntennaStatusGridViewmodel } from '../../../models/antenna-status/antenna-status-grid-viewmodel';
import { SnackBarService } from 'src/app/ui-services/snackbar/snackBar.service';


@Component({
    selector: 'app-antenna-status-home',
    styleUrls: ['./antenna-status-home.component.scss'],
    templateUrl: './antenna-status-home.component.html',
})
export class AntennaStatusHomeComponent implements OnInit {
    // Public Members
    public pageTitle = 'Antenna Status';
    public breadcrumb: any[];
    public antennaStatusGridData: AntennaStatusGridViewmodel[];
    public antennaStatusHomeLoaderName: string = 'antenna-status-home-loader';

    constructor(
        private ngxLoader: NgxUiLoaderService,
        private airportWatchService: AirportWatchService,
        private snackbarService: SnackBarService    
    ) {
        
    }

    ngOnInit() {
        this.loadAntennaStatus();
    }

    private loadAntennaStatus() {
        this.antennaStatusGridData = null;
        this.ngxLoader.startLoader(this.antennaStatusHomeLoaderName);
        this.airportWatchService
            .getAntennaStatusData()
            .subscribe((data: any) => {
                this.antennaStatusGridData = data;
                this.ngxLoader.stopLoader(this.antennaStatusHomeLoaderName);
            });
    }
    public deleteAntenna(antenna: any) {
        this.airportWatchService.deleteAntenna(antenna.boxName)
        .subscribe((data: any) => {
            this.antennaStatusGridData = this.antennaStatusGridData.filter(elem => elem.boxName != antenna.boxName);
            this.snackbarService.showSuccessSnackBar(antenna.boxName + ' deleted successfully');
        }, error => {
            this.snackbarService.showErrorSnackBar(antenna.boxName + ' was not deleted, contact support for more information');
            console.log(error);
        });
    }
}
